import * as Sentry from "@sentry/browser";
import { Form } from "./components/Form";
import { SENTRY } from "./utils/constants";
import { getSearchParams } from "./utils/url";

const preSelectedSubject = new URLSearchParams(window.location.search).get(
  "subject"
);
const contactFormElement = <HTMLFormElement>document.getElementById("contact");
const honeypot = <HTMLInputElement>document.getElementById("_honeypot");
const suggestCorrectionOption = document.getElementById(
  "suggest-correction-option"
);
const subjectCorrection = <HTMLInputElement>(
  document.getElementById("correction")
);
const subjectGeneral = <HTMLInputElement>(
  document.getElementById("general-contact")
);
const subjectFeedback = <HTMLInputElement>document.getElementById("feedback");
const subjectInfo = <HTMLInputElement>document.getElementById("seeking-info");
const subjectPartnership = <HTMLInputElement>(
  document.getElementById("partnership")
);
const suggestCorrectionPathElement = <HTMLInputElement>(
  document.getElementById("suggest-correction-path")
);
const suggestCorrectionTitleElement = <HTMLInputElement>(
  document.getElementById("suggest-correction-title")
);
const pageTitleField = document.getElementById("page-title-field");
const nameElement = <HTMLInputElement>document.getElementById("name");
const emailElement = <HTMLInputElement>document.getElementById("email");
const contentElement = <HTMLTextAreaElement>document.getElementById("content");
const submitButton = <HTMLButtonElement>(
  document.getElementById("contact-submit-btn")
);
const formMessage = document.getElementById("form-message");
const backToPostMessage = document.getElementById("back-to-post");
const backToPostLink = document.getElementById("back-to-post-link");

// Initialize classes
const subjectSelection = [
  subjectCorrection,
  subjectGeneral,
  subjectFeedback,
  subjectInfo,
  subjectPartnership,
];
const contactForm = new Form(contactFormElement);
const params = getSearchParams();

contactForm.registerInputs([nameElement, emailElement, contentElement]);
contactForm.registerSubmitButton(submitButton);

[...contactForm.inputList, ...subjectSelection].forEach((input) => {
  input.addEventListener("change", () => {
    formMessage.innerText = "";
  });
});

// Allow query param to set selected subject
if (preSelectedSubject) {
  (document.getElementById(preSelectedSubject) as HTMLInputElement).checked =
    true;

  nameElement.focus();
}

if (params.suggestCorrection) {
  pageTitleField.classList.remove("hide");
  suggestCorrectionOption.classList.remove("hide");
  subjectCorrection.checked = true;

  subjectSelection.forEach((subject) => {
    if (subject !== subjectCorrection) {
      subject.parentElement.parentElement.removeChild(subject.parentElement);
    }
  });

  suggestCorrectionPathElement.value = params.path;
  suggestCorrectionTitleElement.value = params.title;
}

contactForm.addEventListener("submit", (e) => {
  e.preventDefault();

  const reqHeaders: HeadersInit = new Headers();
  const selectedSubjectLabel = <HTMLLabelElement>(
    document.querySelector(
      `[for="${subjectSelection
        .filter((subjectInput) => subjectInput.checked)[0]
        .getAttribute("id")}"]`
    )
  );

  // Set content-type header
  reqHeaders.set("Content-Type", "application/json");

  // Add breadcrumb
  Sentry.addBreadcrumb({
    category: "contactForm.submit",
    level: SENTRY.LEVEL.Log,
  });

  // Early return if honeypot input has a value
  if (honeypot.value) {
    Sentry.captureEvent({
      message: "honeypot hit",
      level: SENTRY.LEVEL.Warning,
    });

    return false;
  }

  contactForm.submitButton.setAttribute("disabled", String(true));

  fetch("/.netlify/functions/send-message", {
    method: "POST",
    headers: reqHeaders,
    body: JSON.stringify({
      email: emailElement.value,
      name: nameElement.value,
      subject: selectedSubjectLabel.innerText,
      content: contentElement.value,
      title: suggestCorrectionTitleElement.value,
      url: `${window.location.origin}${suggestCorrectionPathElement.value}`,
    }),
  })
    .then((res) => res.json())
    .then(({ status, message }) => {
      contactForm.submitButton.removeAttribute("disabled");

      if (status !== 200) {
        // Create error object to throw
        const reqError = new Error(message);
        reqError.name = "SendMessageError";

        // Display error text to user
        formMessage.innerText =
          "There was an error submitting your information. Please try again.";

        throw reqError;
      } else {
        contactForm.inputList.forEach((input) => {
          input.value = "";
        });

        subjectSelection.forEach((input) => {
          if (input.checked) {
            input.checked = false;
          }
        });

        formMessage.innerText = "Thank you! Your submission has been received";

        if (params.suggestCorrection) {
          backToPostLink.setAttribute("href", params.path);
          backToPostMessage.classList.remove("hide");
        }
      }
    })
    .catch((e) => {
      if (e instanceof Error) {
        throw e;
      } else {
        throw new Error(e);
      }
    });
});
